import React from 'react';
import bem from 'utils/bem.js';
import Icon from 'components/Icon/index.js';
import Text from 'components/Text/index.js';
import { datetimeFromUTC } from 'utils/dayjs.js';
import './index.sass';

const { block, el } = bem('order-placeholder')
export const OrderPlaceholder = ({order}) => {
    const { date, time } = datetimeFromUTC(order.order.event.startDate);
    return (
        <div className={block()}>
            <Icon name={'wave-sine'} />
            <Text serif className={el('title')}>Консультация</Text>
            <Text className={el('time')}>{`${date} ${time}`}</Text>
        </div>
    )
}
